import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import moment from 'moment';
import { sendChatPost } from 'flow/actions/chat-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import UserAvatar from 'flow/components/ui-components/UserAvatar';
import useAppContext from 'flow/hooks/useAppContext';
import useExtension from 'flow/hooks/useExtension';
import useSinglePaneMode from 'flow/hooks/useSinglePaneMode';
import ImagePicker from 'flow/pages/messages/ImagePicker';
import { extractName, getContactAvatar } from 'flow/utils';
import { replaceWhitespaces } from 'flow/utils/message-utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultValue = {
  attachment: null,
  title: '',
  message: '',
  imageSrc: ''
};
var CreatePostModal = function CreatePostModal(_ref) {
  var id = _ref.id;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var _useExtension = useExtension(),
    ownExtension = _useExtension.ownExtension;
  var contact = ownExtension.get('contact');
  var dispatch = useAppDispatch();
  var _useSinglePaneMode = useSinglePaneMode(),
    isSinglePaneMode = _useSinglePaneMode.isSinglePaneMode;
  var clientKey = useAppSelector(function (state) {
    return state.chats.getIn(['client', 'key']);
  });
  var avatarImg = getContactAvatar(contact);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    postContent = _useState2[0],
    setPostContent = _useState2[1];
  var handleSubmit = function handleSubmit() {
    dispatch(sendChatPost(id, clientKey, postContent.title, postContent.message, postContent.attachment ? {
      name: replaceWhitespaces(postContent.attachment.name, '_'),
      file: postContent.attachment
    } : null));
  };
  var handleAttachment = function handleAttachment(attachment) {
    if (attachment) {
      var reader = new FileReader();
      reader.readAsDataURL(attachment);
      reader.onloadend = function () {
        setPostContent(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            imageSrc: reader.result.toString(),
            attachment: attachment
          });
        });
      };
    }
  };
  return /*#__PURE__*/_jsx(BaseModal, {
    open: true,
    header: i18next.t('chat.post.create'),
    onSubmit: handleSubmit,
    disableSubmit: !postContent.title || !postContent.message,
    confirmButtonText: i18next.t('Chat.Create.Button.Create'),
    className: !isSinglePaneMode && 'min-h-[796px] min-w-[688px]',
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-5",
      children: [/*#__PURE__*/_jsx(ImagePicker, {
        imageSrc: postContent.imageSrc,
        removeAttachment: function removeAttachment() {
          setPostContent(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              imageSrc: '',
              attachment: null
            });
          });
        },
        addAttachment: function addAttachment(e) {
          var _e$target;
          handleAttachment((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0]);
          e.target.value = null;
        }
      }), /*#__PURE__*/_jsx("input", {
        "aria-label": i18next.t('Chat.Post.Create.ChatTitle'),
        className: "w-full bg-transparent text-2xl font-bold outline-hidden placeholder:text-gray-500",
        placeholder: i18next.t('Chat.Post.Create.ChatTitle'),
        value: postContent.title,
        type: "text",
        onChange: function onChange(e) {
          var title = e.target.value;
          setPostContent(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              title: title
            });
          });
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-x-2",
          children: [/*#__PURE__*/_jsx(UserAvatar, {
            src: avatarImg,
            size: "small"
          }), /*#__PURE__*/_jsx("p", {
            className: "line-clamp-1 text-sm font-bold",
            children: extractName(contact)
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: "text-xs text-gray-500",
          children: moment().format('HH:mm')
        })]
      }), /*#__PURE__*/_jsx("textarea", {
        "aria-label": i18next.t('input.writemessage'),
        className: "w-full resize-none bg-transparent outline-hidden placeholder:text-gray-500",
        rows: 10,
        placeholder: i18next.t('input.writemessage'),
        value: postContent.message,
        onChange: function onChange(e) {
          var message = e.target.value;
          setPostContent(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              message: message
            });
          });
        }
      })]
    })
  });
};
export default CreatePostModal;